import { useQuery } from '@tanstack/react-query';

import { QUERY_KEYS } from 'api/constants';
import { resolve } from 'api/resolve';
import { assertDefined } from 'utils/values';

import { useQueryValidationApi } from '../query-validation-api';

export function useAllTemplateQueryValidations(templateId?: string) {
  const { getAll } = useQueryValidationApi();
  const { ALL_TEMPLATE_QUERY_VALIDATIONS } = QUERY_KEYS;

  const { data, isLoading, refetch } = useQuery({
    queryKey: [ALL_TEMPLATE_QUERY_VALIDATIONS, templateId],
    queryFn: () => resolve(getAll(assertDefined(templateId))),
    enabled: !!templateId
  });

  return {
    data,
    isLoading,
    refetch
  };
}
